import React from 'react';
import Modal, { ModalProps } from '../Modal';
import Button, { IButtonProps } from '../Button';

// TODO: once all legacy usages are gone, remove this class and use UI.confirm

export interface IConfirmDialogProps extends ModalProps {
  content: React.ReactNode;
  title?: string;
  okButtonContent?: string;
  okButtonId?: string;
  cancelButton?: boolean;
  cancelButtonContent?: string;
  okButton?: boolean;
  okButtonProps?: IButtonProps;
  cancelButtonProps?: IButtonProps;
  onClickOk: () => void;
  onClickCancel?: () => void;
  className?: string;
  buttonsInvertOrder?: boolean;
}

export default function ConfirmDialog({
  isOpen,
  content,
  title = '',
  onClickOk,
  okButton = true,
  okButtonId,
  okButtonProps = { variant: 'danger' },
  okButtonContent = 'OK',
  cancelButton = true,
  cancelButtonProps = { variant: 'default' },
  cancelButtonContent = 'Cancel',
  onClickCancel,
  className,
  buttonsInvertOrder = false,
  ...otherProps
}: React.PropsWithChildren<IConfirmDialogProps>) {
  const _onClickOK = (): void => {
    onClickOk();
  };

  const _onClickCancel = (): void => {
    onClickCancel();
  };

  let buttons = [];

  if (cancelButton) {
    buttons.push(
      <Button key="cancel" {...cancelButtonProps} onClick={_onClickCancel}>
        {cancelButtonContent}
      </Button>
    );
  }

  if (okButton) {
    buttons.push(
      <Button key="ok" id={okButtonId} {...okButtonProps} onClick={_onClickOK}>
        {okButtonContent}
      </Button>
    );
  }

  if (buttonsInvertOrder) buttons = buttons.sort(() => -1);

  return (
    <Modal
      className={`confirm-dialog dialog ${className ? className : ''}`}
      isOpen={isOpen}
      pages={[
        {
          title,
          content: <>{content}</>,
        },
      ]}
      pageNumber={1}
      onClose={onClickCancel}
      header={title && <h3 className="dialog-title">{title}</h3>}
      footer={<section className="buttons-area">{buttons}</section>}
      {...otherProps}
    />
  );
}
